import { saveForGoogleAnalyticsToSessionStorage } from "client/api/google-analytics-service";
import React from "react";
import { addRecentSearch } from "client/api/recent-searches-service";
import { useDataContext } from "client/context/DataContext";
import {
  ANALYTICS_SUGGESTED_BRAND,
  BRANDS,
  DATA_LAYER,
} from "../../utils/constants";
import SectionTitle from "../section/section-title";
import Brand from "./brand/brand.component";
import {
  StyledBrandWrapper,
  StyledBrandsContainer,
  DeviceWrapper,
  WhiteRightShadow,
} from "./brands.styles";
import { setSearchToSessionStorage } from "client/api/data-layer-service";

export interface BrandsProps {
  label: string;
  brands: string[];
}

const handleBrandClicked = (brand: string): void => {
  addRecentSearch(brand);
  saveForGoogleAnalyticsToSessionStorage(ANALYTICS_SUGGESTED_BRAND);
  setSearchToSessionStorage(DATA_LAYER.SUGGESTED_BRAND);
};

const Brands = () => {
  const { brands } = useDataContext();

  if (!brands?.length) return null;
  return (
    <StyledBrandWrapper data-testid="brands-wrapper">
      <SectionTitle
        id="search-brands-section-name"
        dataTestId="brands-section-name"
      >
        {BRANDS}
      </SectionTitle>
      <DeviceWrapper>
        <StyledBrandsContainer
          data-testid="brands-container"
          role="list"
          aria-labelledby="search-brands-section-name"
        >
          {brands.map((brand) => (
            <Brand
              key={brand}
              dataTestId="brand"
              brand={brand}
              onClick={handleBrandClicked}
            />
          ))}
        </StyledBrandsContainer>
        <WhiteRightShadow />
      </DeviceWrapper>
    </StyledBrandWrapper>
  );
};

export default Brands;
